import { h } from "omi";

import { IconProps } from "@/wc/components";

export function MessageQuestionCircleIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 20 20">
      <path
        d="M8.75 7.502a1.874 1.874 0 0 1 3.64.624c0 1.25-1.873 1.874-1.873 1.874m.024 2.5h.009m-.134 4.167a7.083 7.083 0 1 0-6.713-4.82c.09.268.135.401.143.504a.75.75 0 0 1-.023.271c-.026.1-.082.204-.194.412l-1.363 2.523c-.194.36-.292.54-.27.679.02.12.09.227.195.29.12.074.323.053.73.011l4.268-.441c.129-.014.194-.02.252-.018a.753.753 0 0 1 .156.02c.057.014.13.042.274.097.79.305 1.648.472 2.545.472Z"
        stroke="currentColor"
        stroke-width="1.667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
